import { render } from "./RegistroActividades.vue?vue&type=template&id=28f2129a&scoped=true"
import script from "./RegistroActividades.vue?vue&type=script&lang=js"
export * from "./RegistroActividades.vue?vue&type=script&lang=js"

import "./RegistroActividades.vue?vue&type=style&index=0&id=28f2129a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28f2129a"]])

export default __exports__